import { useQuery } from "@tanstack/react-query";
import axios from "axios";

const fetchMainCategoryCompanies = async (mainCategoryId: string) => {
  const url = `https://kaman.rest/api/companies?company_category=${mainCategoryId}`;
  const response = await axios.get(url);
  return response.data.data.companies.map((company: any) => {
    return {
      id: company.id,
      name: company.name,
      image: company.image,
    };
  });
};

export function useMainCategoryCompanies(mainCategoryId: string) {
  return useQuery({
    queryKey: ["main-category-companies", mainCategoryId],
    queryFn: () => fetchMainCategoryCompanies(mainCategoryId),
  });
}
